(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milk-frog-pet"] && !Shopify.designMode) return;
  try {
    
    if (!customElements.get('milk-frog-pet')) {
      customElements.define('milk-frog-pet', class extends HTMLElement {
        connectedCallback() {
          this.cleanup?.();
          const root = this;
          const petButton = root.querySelector('.milk-frog-pet__character');
          const dismissButton = root.querySelector('.milk-frog-pet__dismiss');
          const dialog = root.querySelector('.milk-frog-search');
          const input = root.querySelector('.milk-frog-search__input');
          const results = root.querySelector('.milk-frog-search__results');
          const status = root.querySelector('[role="status"]');
          if (!petButton || !dialog || !input) return;
          const controller = new AbortController();
          const options = { signal: controller.signal };
          const motion = matchMedia('(prefers-reduced-motion: reduce)');
          let moveTimer, stopTimer, searchTimer, frame, searchController;
          let revision = 0;
          let drag = null;
          let suppressClick = false;
          let mouseOver = false;

          const stopPet = () => {
            clearTimeout(moveTimer);
            clearTimeout(stopTimer);
            cancelAnimationFrame(frame);
            const left = root.getBoundingClientRect().left;
            root.style.setProperty('--frog-move-duration', '0ms');
            root.style.left = left + 'px';
            root.classList.remove('is-moving');
          };
          const canMove = () => root.isConnected && !root.hidden && !dialog.open &&
            !motion.matches && !document.hidden && root.getClientRects().length &&
            !drag && !mouseOver && !root.matches(':focus-within') && !window.Shopify?.designMode;
          const scheduleMove = () => {
            clearTimeout(moveTimer);
            if (canMove()) moveTimer = setTimeout(movePet, 3200 + Math.random() * 4200);
          };
          const movePet = () => {
            if (!canMove()) return;
            const current = root.getBoundingClientRect().left;
            const maxLeft = Math.max(16, innerWidth - root.offsetWidth - 16);
            const target = 16 + Math.random() * Math.max(0, maxLeft - 16);
            const duration = Math.min(6200, Math.max(2200, Math.abs(target - current) * 12));
            root.dataset.direction = target < current ? 'left' : 'right';
            root.style.setProperty('--frog-move-duration', duration + 'ms');
            root.classList.add('is-moving');
            frame = requestAnimationFrame(() => { root.style.left = target + 'px'; });
            stopTimer = setTimeout(() => { root.classList.remove('is-moving'); scheduleMove(); }, duration + 80);
          };
          const cancelSearch = () => {
            revision++;
            clearTimeout(searchTimer);
            searchController?.abort();
            results.removeAttribute('aria-busy');
          };
          const renderMessage = (message) => {
            results.replaceChildren();
            const p = document.createElement('p');
            p.className = 'milk-frog-search__message';
            p.textContent = message;
            results.append(p);
            status.textContent = message;
          };
          const renderProducts = (products) => {
            results.replaceChildren();
            products.forEach((product) => {
              const link = document.createElement('a');
              link.className = 'milk-frog-search__result';
              link.href = product.url;
              const imageUrl = product.featured_image?.url || product.image;
              const image = document.createElement(imageUrl ? 'img' : 'span');
              image.className = 'milk-frog-search__thumb';
              if (imageUrl) {
                image.alt = '';
                image.loading = 'lazy';
                image.width = 58;
                image.height = 58;
                image.src = imageUrl + (imageUrl.includes('?') ? '&' : '?') + 'width=116';
              } else image.setAttribute('aria-hidden', 'true');
              const title = document.createElement('p');
              title.className = 'milk-frog-search__product-title';
              title.textContent = product.title;
              link.append(image, title);
              results.append(link);
            });
            status.textContent = products.length + ' ' + root.dataset.resultsText;
          };
          const searchProducts = async (query, requestRevision) => {
            searchController = new AbortController();
            const params = new URLSearchParams({
              q: query, 'resources[type]': 'product', 'resources[limit]': '6',
              'resources[options][unavailable_products]': 'last'
            });
            renderMessage(root.dataset.loadingText);
            results.setAttribute('aria-busy', 'true');
            try {
              const response = await fetch(root.dataset.searchUrl + '?' + params, {
                signal: searchController.signal, headers: { Accept: 'application/json' }
              });
              if (!response.ok) throw new Error('Search request failed');
              const data = await response.json();
              if (revision !== requestRevision || input.value.trim() !== query || !dialog.open) return;
              const products = data.resources?.results?.products || [];
              if (products.length) renderProducts(products);
              else renderMessage(root.dataset.noResults);
            } catch (error) {
              if (error.name !== 'AbortError' && revision === requestRevision && dialog.open) {
                renderMessage(root.dataset.searchError);
              }
            } finally {
              if (revision === requestRevision) results.removeAttribute('aria-busy');
            }
          };
          const closeDialog = () => { if (dialog.open) dialog.close(); };
          const placePet = (left, bottom) => {
            const maxLeft = Math.max(16, innerWidth - root.offsetWidth - 16);
            const maxBottom = Math.max(16, innerHeight - root.offsetHeight - 16);
            root.style.left = Math.max(16, Math.min(left, maxLeft)) + 'px';
            root.style.setProperty('--frog-drag-bottom', Math.max(16, Math.min(bottom, maxBottom)) + 'px');
          };
          const finishDrag = (event) => {
            if (!drag || event.pointerId !== drag.pointerId) return;
            const wasDragged = drag.moved;
            drag = null;
            root.classList.remove('is-dragging');
            if (petButton.hasPointerCapture(event.pointerId)) petButton.releasePointerCapture(event.pointerId);
            if (wasDragged) {
              suppressClick = true;
              petButton.blur();
            }
            scheduleMove();
          };
          this.cleanup = () => {
            stopPet();
            cancelSearch();
            controller.abort();
            if (drag && petButton.hasPointerCapture(drag.pointerId)) petButton.releasePointerCapture(drag.pointerId);
            drag = null;
            root.classList.remove('is-dragging');
            closeDialog();
          };

          try {
            if (localStorage.getItem(root.dataset.storageKey) === 'true' && !window.Shopify?.designMode) {
              root.hidden = true;
              return;
            }
          } catch (_) { /* Search and motion work even when storage is unavailable. */ }

          petButton.addEventListener('pointerdown', (event) => {
            if (!event.isPrimary || event.button !== 0 || dialog.open) return;
            if (event.pointerType === 'mouse') event.preventDefault();
            stopPet();
            suppressClick = false;
            const bounds = root.getBoundingClientRect();
            drag = {
              pointerId: event.pointerId, x: event.clientX, y: event.clientY,
              lastX: event.clientX, left: bounds.left, bottom: innerHeight - bounds.bottom, moved: false
            };
            petButton.setPointerCapture(event.pointerId);
          }, options);
          petButton.addEventListener('pointermove', (event) => {
            if (!drag || event.pointerId !== drag.pointerId) return;
            const dx = event.clientX - drag.x;
            const dy = event.clientY - drag.y;
            if (!drag.moved && Math.hypot(dx, dy) < 6) return;
            drag.moved = true;
            event.preventDefault();
            root.classList.add('is-dragging');
            if (Math.abs(event.clientX - drag.lastX) > 1) {
              root.dataset.direction = event.clientX < drag.lastX ? 'left' : 'right';
            }
            drag.lastX = event.clientX;
            placePet(drag.left + dx, drag.bottom - dy);
          }, { ...options, passive: false });
          petButton.addEventListener('pointerup', finishDrag, options);
          petButton.addEventListener('pointercancel', finishDrag, options);
          petButton.addEventListener('lostpointercapture', finishDrag, options);
          petButton.addEventListener('dragstart', (event) => event.preventDefault(), options);
          petButton.addEventListener('click', (event) => {
            if (suppressClick && event.detail !== 0) {
              suppressClick = false;
              event.preventDefault();
              return;
            }
            stopPet();
            if (!dialog.open) dialog.showModal();
            input.focus();
          }, options);
          dismissButton.addEventListener('click', () => {
            stopPet();
            cancelSearch();
            closeDialog();
            root.hidden = true;
            try { localStorage.setItem(root.dataset.storageKey, 'true'); } catch (_) {}
          }, options);
          root.querySelector('.milk-frog-search__close').addEventListener('click', closeDialog, options);
          dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); }, options);
          dialog.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
              event.preventDefault();
              closeDialog();
            }
          }, { ...options, capture: true });
          dialog.addEventListener('close', () => {
            cancelSearch();
            if (root.isConnected && !root.hidden) petButton.focus();
            scheduleMove();
          }, options);
          input.addEventListener('input', () => {
            cancelSearch();
            results.replaceChildren();
            status.textContent = '';
            const query = input.value.trim();
            if (query.length < 2) return;
            const requestRevision = revision;
            searchTimer = setTimeout(() => searchProducts(query, requestRevision), 220);
          }, options);
          root.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') { mouseOver = true; stopPet(); }
          }, options);
          root.addEventListener('pointerleave', (event) => {
            if (event.pointerType === 'mouse') { mouseOver = false; scheduleMove(); }
          }, options);
          root.addEventListener('focusin', stopPet, options);
          root.addEventListener('focusout', () => { queueMicrotask(scheduleMove); }, options);
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) stopPet(); else scheduleMove();
          }, options);
          motion.addEventListener('change', () => { stopPet(); scheduleMove(); }, options);
          window.addEventListener('resize', () => {
            stopPet();
            const bounds = root.getBoundingClientRect();
            placePet(bounds.left, innerHeight - bounds.bottom);
            scheduleMove();
          }, { ...options, passive: true });
          scheduleMove();
        }
        disconnectedCallback() { this.cleanup?.(); }
      });
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => root.querySelectorAll('[data-sc-contact-topic]').forEach(select => {
    if (select.dataset.scTopicReady) return;
    select.dataset.scTopicReady = 'true';
    const panel = select.closest('.sc-contact-panel');
    const group = panel?.querySelector('[data-sc-contact-purchase]');
    if (!group) return;
    const update = () => {
      const show = ['order', 'warranty', 'returns'].includes(select.value);
      group.hidden = !show;
      group.querySelectorAll('input').forEach(input => { input.disabled = !show; });
    };
    select.addEventListener('change', update);
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-header"]) return;
  try {
    
if (!window.scInterfaceReady) {
  window.scInterfaceReady = true;
  let cartNoticeTimer;
  let cartVersion = 0;
  const updateCartCount = value => {
    const count = Number(value);
    if (value == null || !Number.isFinite(count) || count < 0) return;
    document.querySelectorAll('[data-sc-cart-count]').forEach(badge => {
      badge.textContent = String(Math.floor(count));
    });
  };
  const hideCartNotice = () => {
    window.clearTimeout(cartNoticeTimer);
    const notice = document.querySelector('[data-sc-cart-notice]');
    if (!notice) return;
    notice.removeAttribute('data-visible');
    cartNoticeTimer = window.setTimeout(() => { notice.hidden = true; }, 220);
  };
  const showCartNotice = () => {
    const notice = document.querySelector('[data-sc-cart-notice]');
    if (!notice) return;
    window.clearTimeout(cartNoticeTimer);
    notice.hidden = false;
    window.requestAnimationFrame(() => notice.setAttribute('data-visible', ''));
    const dismiss = () => {
      if (notice.contains(document.activeElement) || notice.matches(':hover')) {
        cartNoticeTimer = window.setTimeout(dismiss, 1000);
        return;
      }
      hideCartNotice();
    };
    cartNoticeTimer = window.setTimeout(dismiss, 5000);
  };
  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, event => {
      const version = ++cartVersion;
      event.promise?.then(({ cart, detail }) => {
        if (version !== cartVersion) return;
        const count = cart?.totalQuantity ?? (Array.isArray(detail?.items)
          ? detail.items.reduce((total, item) => total + Number(item.quantity || 0), 0)
          : undefined);
        updateCartCount(count);
        if (event.action === 'add' && !detail?.didError) showCartNotice();
      }).catch(() => {});
    });
  }).catch(() => {});
  document.addEventListener('click', event => {
    if (event.target.closest('[data-sc-cart-notice-close]')) hideCartNotice();
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    hideCartNotice();
    const cartLink = document.querySelector('[data-sc-header] .sc-cart');
    if (!cartLink) return;
    const version = ++cartVersion;
    const cartUrl = new URL(cartLink.href);
    cartUrl.pathname += '.js';
    fetch(cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(response => response.ok ? response.json() : Promise.reject())
      .then(cart => { if (version === cartVersion) updateCartCount(cart.item_count); })
      .catch(() => {});
  });
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const navGroups = new WeakMap();
  const closeNavGroups = (except = null, instant = false) => {
    document.querySelectorAll('.sc-nav-group').forEach(group => {
      if (group !== except) navGroups.get(group)?.setExpanded(false, instant);
    });
  };
  const initNavigation = () => {
    document.querySelectorAll('.sc-nav-group').forEach(group => {
      if (navGroups.has(group)) return;
      const summary = group.querySelector(':scope > summary');
      const panel = group.querySelector(':scope > .sc-nav-panel');
      if (!summary || !panel) return;
      let expanded = group.open;
      let animation = null;
      let leaveTimer;
      const clearLeave = () => window.clearTimeout(leaveTimer);
      const setExpanded = (next, instant = false) => {
        clearLeave();
        if (expanded === next && !instant) return;
        const wasOpen = group.open;
        const style = wasOpen ? getComputedStyle(panel) : null;
        const start = {
          opacity: style ? style.opacity : '0',
          transform: style ? style.transform : 'translateY(-10px)'
        };
        animation?.cancel();
        animation = null;
        expanded = next;
        group.dataset.expanded = String(next);
        summary.setAttribute('aria-expanded', String(next));
        if (!next && panel.contains(document.activeElement)) summary.focus({ preventScroll: true });
        panel.inert = !next;
        if (next) {
          closeNavGroups(group);
          group.open = true;
        }
        if (instant || reducedMotion.matches || !panel.animate || (!wasOpen && !next)) {
          group.open = next;
          return;
        }
        animation = panel.animate([
          start,
          { opacity: next ? '1' : '0', transform: next ? 'translateY(0)' : 'translateY(-8px)' }
        ], { duration: next ? 240 : 180, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' });
        const current = animation;
        current.onfinish = () => {
          if (animation !== current) return;
          group.open = expanded;
          current.cancel();
          animation = null;
        };
      };
      const scheduleClose = () => {
        clearLeave();
        leaveTimer = window.setTimeout(() => {
          if (desktopHover.matches && group.matches(':hover')) return;
          if (group.querySelector(':focus-visible')) return;
          setExpanded(false);
        }, 160);
      };
      navGroups.set(group, { setExpanded });
      group.dataset.expanded = String(expanded);
      summary.setAttribute('aria-expanded', String(expanded));
      panel.inert = !expanded;
      group.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch' || !desktopHover.matches) return;
        clearLeave();
        setExpanded(true);
      });
      group.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'touch' && desktopHover.matches) scheduleClose();
      });
      group.addEventListener('focusin', clearLeave);
      group.addEventListener('focusout', event => {
        if (!group.contains(event.relatedTarget)) scheduleClose();
      });
      summary.addEventListener('click', event => {
        event.preventDefault();
        setExpanded(!expanded);
      });
      summary.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        setExpanded(true);
        panel.querySelector('a[href], button:not([disabled])')?.focus();
      });
    });
  };
  initNavigation();
  document.addEventListener('shopify:section:load', initNavigation);
  desktopHover.addEventListener('change', () => closeNavGroups(null, true));
  reducedMotion.addEventListener('change', () => closeNavGroups(null, true));
  document.addEventListener('click', (event) => {
    const menu = document.getElementById('ScMobileMenu');
    const menuButton = event.target.closest('[data-sc-menu]');
    if (menuButton && menu) {
      const open = menuButton.getAttribute('aria-expanded') !== 'true';
      menuButton.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
    }
    if (event.target.closest('#ScMobileMenu a, #ScMobileMenu [data-sc-placeholder]') && menu) {
      menu.hidden = true;
      document.querySelector('[data-sc-menu]')?.setAttribute('aria-expanded', 'false');
    }
    closeNavGroups(event.target.closest('.sc-nav-group'));
    const placeholder = event.target.closest('[data-sc-placeholder]');
    if (placeholder) {
      const dialog = document.getElementById('ScContentNotice');
      if (dialog) { dialog.querySelector('h2').textContent = placeholder.dataset.scPlaceholder; dialog.showModal(); }
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openGroup = event.target.closest('.sc-nav-group[open], .sc-mobile-group[open]');
    if (openGroup) {
      if (navGroups.has(openGroup)) navGroups.get(openGroup).setExpanded(false);
      else openGroup.open = false;
      openGroup.querySelector('summary')?.focus({ preventScroll: true });
      return;
    }
    closeNavGroups();
    const menu = document.getElementById('ScMobileMenu');
    if (menu && !menu.hidden) {
      menu.hidden = true;
      const button = document.querySelector('[data-sc-menu]');
      button?.setAttribute('aria-expanded', 'false');
      button?.focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sc-hero-inspector')) {
  customElements.define('sc-hero-inspector', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const trigger = this.querySelector('.sc-hero-inspect');
      const panel = this.querySelector('.sc-hero-specs');
      if (!trigger || !(panel instanceof HTMLDialogElement)) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const root = this.closest('.sc-hero');
      const closeButton = panel.querySelector('.sc-hero-specs-close');
      const hover = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      let mode = null;
      let pointerInside = false;
      let previewDismissed = false;
      const clearClose = () => clearTimeout(this.closeTimer);
      const isInteractive = target => target instanceof Node && (trigger.contains(target) || panel.contains(target));
      const sync = () => {
        root.toggleAttribute('data-inspect-open', panel.open);
        trigger.setAttribute('aria-expanded', String(panel.open));
        if (!panel.open) {
          mode = null;
          panel.removeAttribute('data-inspector-mode');
        }
      };
      const close = (restoreFocus = false) => {
        clearClose();
        previewDismissed = pointerInside;
        const shouldRestore = restoreFocus && (mode === 'modal' || panel.contains(document.activeElement));
        panel.close();
        sync();
        if (shouldRestore && trigger.isConnected) trigger.focus({ preventScroll: true });
      };
      const scheduleClose = () => {
        clearClose();
        this.closeTimer = setTimeout(() => {
          if (mode === 'preview' && !pointerInside && !isInteractive(document.activeElement)) close();
        }, 200);
      };
      const openPreview = () => {
        clearClose();
        if (mode === 'modal' || panel.open || previewDismissed) return;
        mode = 'preview';
        panel.setAttribute('data-inspector-mode', mode);
        // A nonmodal hover preview must not take keyboard focus. Setting open
        // displays the dialog without show()'s automatic focusing steps.
        panel.setAttribute('open', '');
        sync();
      };
      const openModal = () => {
        clearClose();
        if (mode === 'modal') return close(true);
        previewDismissed = false;
        if (panel.open) panel.close();
        mode = 'modal';
        panel.setAttribute('data-inspector-mode', mode);
        panel.showModal();
        sync();
        closeButton.focus({ preventScroll: true });
      };
      const enter = event => {
        if (!hover.matches || event.pointerType === 'touch') return;
        pointerInside = true;
        clearClose();
        if (event.currentTarget === trigger) openPreview();
      };
      const leave = event => {
        pointerInside = isInteractive(event.relatedTarget);
        if (!pointerInside) {
          previewDismissed = false;
          scheduleClose();
        }
      };
      trigger.addEventListener('pointerenter', enter, options);
      trigger.addEventListener('pointerleave', leave, options);
      panel.addEventListener('pointerenter', enter, options);
      panel.addEventListener('pointerleave', leave, options);
      trigger.addEventListener('click', openModal, options);
      closeButton.addEventListener('click', () => close(true), options);
      this.addEventListener('focusin', event => {
        if (isInteractive(event.target)) clearClose();
      }, options);
      this.addEventListener('focusout', event => {
        if (!isInteractive(event.relatedTarget)) scheduleClose();
      }, options);
      panel.addEventListener('close', sync, options);
      panel.addEventListener('cancel', event => {
        event.preventDefault();
        close(true);
      }, options);
      panel.addEventListener('click', event => {
        if (mode !== 'modal' || event.target !== panel) return;
        const rect = panel.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(true);
      }, options);
      document.addEventListener('pointerdown', event => {
        if (mode === 'preview' && !isInteractive(event.target)) close();
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && mode === 'preview') {
          event.preventDefault();
          close(true);
        }
      }, options);
      hover.addEventListener('change', () => {
        pointerInside = false;
        if (mode === 'preview') close();
      }, options);
      sync();
      trigger.disabled = false;
      root.setAttribute('data-inspect-ready', '');
    }
    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      this.querySelector('.sc-hero-specs')?.close();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-journey"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sc-journey-carousel')) {
  customElements.define('sc-journey-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('[data-journey-track]');
      if (!this.track) return;
      this.slides = [...this.track.querySelectorAll('[data-journey-slide]')];
      this.autoplay = this.dataset.autoplay === 'true';
      const speed = Number(this.dataset.speed);
      this.speed = Number.isFinite(speed) && speed > 0 ? speed : 36;
      this.visible = !('IntersectionObserver' in window);
      this.editorPaused = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const on = (target, type, callback) => target.addEventListener(type, callback, { signal: this.abort.signal });
      this.tick = time => {
        if (!this.running) return;
        const delta = this.lastTime ? Math.min(64, time - this.lastTime) : 0;
        this.lastTime = time;
        this.position = (this.position + this.speed * delta / 1000) % this.loopWidth;
        this.track.scrollTo({ left: this.position, behavior: 'instant' });
        this.frame = requestAnimationFrame(this.tick);
      };
      on(document, 'visibilitychange', () => this.updateRunning());
      on(this.reduced, 'change', () => this.refresh());
      on(document, 'shopify:block:select', event => {
        const slide = this.slides.find(item => item.dataset.blockId === String(event.detail?.blockId));
        if (!slide || !window.Shopify?.designMode) return;
        this.editorPaused = true;
        this.selectedBlock = slide.dataset.blockId;
        this.updateRunning();
        this.track.scrollTo({ left: this.positions[this.slides.indexOf(slide)], behavior: 'instant' });
      });
      on(document, 'shopify:block:deselect', event => {
        if (String(event.detail?.blockId) !== this.selectedBlock) return;
        this.editorPaused = false;
        this.selectedBlock = null;
        this.updateRunning();
      });
      this.resizeObserver = new ResizeObserver(() => this.refresh());
      this.resizeObserver.observe(this.track);
      this.slides.forEach(slide => this.resizeObserver.observe(slide));
      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.updateRunning();
        });
        this.intersectionObserver.observe(this);
      }
      this.refresh();
    }

    disconnectedCallback() {
      this.stop();
      this.abort?.abort();
      this.abort = null;
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this.removeClones();
    }

    removeClones() {
      this.track.querySelectorAll('[data-journey-clone]').forEach(clone => clone.remove());
    }

    refresh() {
      const prior = this.loopWidth ? (this.position || 0) % this.loopWidth : this.track.scrollLeft;
      this.stop();
      this.removeClones();
      this.loopWidth = 0;
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const origin = this.slides[0]?.offsetLeft || 0;
      this.positions = this.slides.map(slide => slide.offsetLeft - origin);
      if (this.slides.length > 1 && maximum > 1 && this.autoplay && !this.reduced.matches) {
        this.slides.forEach(slide => {
          const clone = slide.cloneNode(true);
          [clone, ...clone.querySelectorAll('*')].forEach(element => {
            [...element.attributes].forEach(attribute => {
              if (attribute.name === 'id' || attribute.name === 'data-journey-slide' || attribute.name === 'data-block-id' || attribute.name.startsWith('data-shopify')) element.removeAttribute(attribute.name);
            });
          });
          clone.dataset.journeyClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          this.track.append(clone);
        });
        this.loopWidth = this.track.querySelector('[data-journey-clone]').offsetLeft - origin;
      }
      this.position = this.loopWidth ? prior % this.loopWidth : 0;
      this.track.scrollTo({ left: this.position, behavior: 'instant' });
      this.updateRunning();
    }

    stop() {
      cancelAnimationFrame(this.frame);
      this.running = false;
      this.lastTime = 0;
    }

    updateRunning() {
      const allowed = this.isConnected && this.autoplay && this.loopWidth > 0 && !this.reduced.matches && this.visible && !document.hidden && !this.editorPaused;
      if (!allowed) { this.stop(); return; }
      if (this.running) return;
      this.position = this.track.scrollLeft % this.loopWidth;
      this.lastTime = 0;
      this.running = true;
      this.frame = requestAnimationFrame(this.tick);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-model-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sc-model-gallery')) {
  customElements.define('sc-model-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-sc-gallery-button]');
        if (button) this.select(button.dataset.scGalleryButton);
      }, { signal: this.controller.signal });
      this.addEventListener('keydown', (event) => {
        const button = event.target.closest('[data-sc-gallery-button]');
        if (!button || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const buttons = [...this.querySelectorAll('[data-sc-gallery-button]')];
        const current = buttons.indexOf(button);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        event.preventDefault();
        this.select(buttons[next].dataset.scGalleryButton);
        buttons[next].focus();
      }, { signal: this.controller.signal });
    }
    select(index) {
      this.querySelectorAll('[data-sc-gallery-slide]').forEach((slide) => { slide.hidden = slide.dataset.scGallerySlide !== index; });
      this.querySelectorAll('[data-sc-gallery-button]').forEach((button) => { button.setAttribute('aria-pressed', String(button.dataset.scGalleryButton === index)); });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-newsletter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sc-newsletter-preview')) {
  customElements.define('sc-newsletter-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.scBound) return;
      this.scBound = true;
      this.querySelector('[data-sc-newsletter-check]')?.addEventListener('click', () => this.checkEmail());
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target instanceof HTMLInputElement && event.target.type === 'email') {
          event.preventDefault();
          this.checkEmail();
        }
      });
    }
    checkEmail() {
      const status = this.querySelector('[data-sc-newsletter-status]');
      const invalid = [...this.querySelectorAll('input')].find(field => !field.checkValidity());
      if (invalid) {
        status.textContent = 'Please enter a valid email and confirm your preference. No email has been saved.';
        invalid.reportValidity();
        return;
      }
      status.textContent = 'Email checked. You have not been subscribed because the email service is not connected yet.';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-product-nav"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sc-product-navigation')) {
  customElements.define('sc-product-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.closest('.shopify-section')?.classList.add('sc-product-nav-section');
      this.links = [...this.querySelectorAll('[data-sc-product-link]')];
      this.refresh = this.refresh.bind(this);
      this.update = this.update.bind(this);
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-sc-product-link]');
        const target = this.targets?.get(link);
        if (!target || link.hidden) return;
        event.preventDefault();
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        this.update();
        target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        history.pushState(null, '', link.getAttribute('href'));
      }, options);
      const queueUpdate = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      document.addEventListener('scroll', queueUpdate, { ...options, capture: true, passive: true });
      window.addEventListener('resize', this.refresh, options);
      document.addEventListener('shopify:section:load', this.refresh, options);
      document.addEventListener('shopify:section:reorder', this.refresh, options);
      document.addEventListener('shopify:section:unload', () => requestAnimationFrame(this.refresh), options);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.refresh, { ...options, once: true });
      else requestAnimationFrame(this.refresh);
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
    refresh() {
      if (!this.isConnected) return;
      const nativeOverview = document.querySelector('[id^="ProductInformation-"]')?.closest('.shopify-section');
      const overview = document.getElementById('model-overview') || nativeOverview;
      this.targets = new Map();
      this.links.forEach((link) => {
        const key = link.dataset.scProductLink;
        const target = key === 'overview' ? overview : document.querySelector(`[data-sc-product-target="${key}"]`);
        const visible = Boolean(target && target.id && target.getClientRects().length);
        link.hidden = !visible;
        if (visible) { link.setAttribute('href', `#${target.id}`); this.targets.set(link, target); }
        else link.removeAttribute('href');
      });
      this.hidden = this.targets.size < 2;
      this.update();
    }
    update() {
      if (!this.isConnected || this.hidden) return;
      let headerOffset = 0;
      document.querySelectorAll('.sc-header, header-component').forEach((header) => {
        let element = header;
        while (element && element !== document.body) {
          const position = getComputedStyle(element).position;
          if (position === 'fixed' || position === 'sticky') {
            const rect = element.getBoundingClientRect();
            if (rect.top <= 1 && rect.bottom > 0) headerOffset = Math.max(headerOffset, rect.bottom);
            break;
          }
          element = element.parentElement;
        }
      });
      this.offset = headerOffset;
      this.closest('.shopify-section')?.style.setProperty('--sc-product-header-offset', `${headerOffset}px`);
      let active;
      this.targets.forEach((target, link) => {
        target.style.scrollMarginTop = `${headerOffset + this.offsetHeight + 20}px`;
        if (target.getBoundingClientRect().top <= headerOffset + this.offsetHeight + 48) active = link;
      });
      if (!active) active = this.targets.keys().next().value;
      this.links.forEach((link) => link === active ? link.setAttribute('aria-current', 'location') : link.removeAttribute('aria-current'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-resources"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sc-resource-library')) {
  customElements.define('sc-resource-library', class extends HTMLElement {
    connectedCallback() {
      if (this.scInitialized) return;
      this.scInitialized = true;
      this.cards = [...this.querySelectorAll('[data-sc-resource]')];
      this.search = this.querySelector('[data-sc-resource-search]');
      this.model = this.querySelector('[data-sc-resource-model]');
      this.type = this.querySelector('[data-sc-resource-type]');
      this.count = this.querySelector('[data-sc-resource-count]');
      this.empty = this.querySelector('[data-sc-resource-no-results]');
      this.reset = this.querySelector('.sc-resource-results-bar [data-sc-resource-reset]');
      if (!this.cards.length || !this.search || !this.model || !this.type) return;
      const models = [...new Set(this.cards.map(card => card.dataset.model.trim()).filter(Boolean))].sort((a, b) => a.localeCompare(b));
      models.forEach(name => {
        const option = document.createElement('option');
        option.value = name;
        option.textContent = name;
        this.model.appendChild(option);
      });
      this.querySelector('[data-sc-resource-filters]').hidden = false;
      this.search.addEventListener('input', () => this.filter());
      this.model.addEventListener('change', () => this.filter());
      this.type.addEventListener('change', () => this.filter());
      this.querySelectorAll('[data-sc-resource-reset]').forEach(button => button.addEventListener('click', () => {
        this.search.value = '';
        this.model.value = '';
        this.type.value = '';
        this.filter();
        this.search.focus();
      }));
      this.filter();
    }
    filter() {
      const query = this.search.value.trim().toLocaleLowerCase();
      const selectedModel = this.model.value;
      const selectedType = this.type.value;
      let visible = 0;
      this.cards.forEach(card => {
        const matchesModel = !selectedModel || !card.dataset.model.trim() || card.dataset.model.trim() === selectedModel;
        const matchesType = !selectedType || card.dataset.type === selectedType;
        const matchesQuery = !query || card.dataset.search.toLocaleLowerCase().includes(query);
        card.hidden = !(matchesModel && matchesType && matchesQuery);
        if (!card.hidden) visible += 1;
        else card.querySelectorAll('video').forEach(video => video.pause());
      });
      this.count.textContent = `${visible} ${visible === 1 ? 'resource' : 'resources'}${query || selectedModel || selectedType ? ` of ${this.cards.length}` : ''}`;
      this.empty.hidden = visible !== 0;
      this.reset.hidden = !(query || selectedModel || selectedType);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-welcome-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sc-welcome-offer')) {
    customElements.define('sc-welcome-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.launcher = this.querySelector('.sc-offer-launcher');
        this.key = 'ttscooter-welcome-offer-v1';
        this.isEditor = this.dataset.editor === 'true';
        this.restorePosition();
        this.launcher.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); this.suppressClick = false; return; }
          this.open();
        }, options);
        this.querySelectorAll('.sc-offer-close, .sc-offer-later').forEach(button => button.addEventListener('click', () => this.close(), options));
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
        this.dialog.addEventListener('click', event => {
          const box = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) this.close();
        }, options);
        this.launcher.addEventListener('pointerdown', event => this.startDrag(event), options);
        this.launcher.addEventListener('pointermove', event => this.moveDrag(event), options);
        this.launcher.addEventListener('pointerup', () => this.endDrag(), options);
        this.launcher.addEventListener('pointercancel', () => this.endDrag(), options);
        window.addEventListener('resize', () => this.clampPosition(), options);
        window.visualViewport?.addEventListener('resize', () => this.clampPosition(), options);
        const success = this.querySelector('[data-offer-success]');
        if (success) { this.writeState({ subscribed: true, dismissed: true }); this.open(); }
        else if (this.querySelector('[data-offer-errors]')) this.open();
        else if (!this.isEditor && !this.readState().dismissed) {
          this.openTimer = setTimeout(() => {
            if (document.querySelector('dialog[open]')) return;
            this.open();
          }, Number(this.dataset.delay) || 3000);
        }
        if (this.readState().subscribed) this.launcher.hidden = true;
      }
      disconnectedCallback() {
        clearTimeout(this.openTimer); clearTimeout(this.closeTimer);
        this.controller?.abort(); this.controller = null;
        if (this.dialog?.open) this.dialog.close();
      }
      readState() { try { return JSON.parse(localStorage.getItem(this.key) || '{}') || {}; } catch { return {}; } }
      writeState(values) { try { localStorage.setItem(this.key, JSON.stringify({ ...this.readState(), ...values })); } catch {} }
      open() {
        clearTimeout(this.closeTimer);
        this.returnFocus = document.activeElement;
        if (!this.dialog.open) this.dialog.showModal();
        this.launcher.hidden = true;
        requestAnimationFrame(() => this.dialog.setAttribute('data-visible', ''));
      }
      close() {
        if (!this.dialog.open) return;
        this.dialog.removeAttribute('data-visible');
        this.writeState({ dismissed: true });
        this.closeTimer = setTimeout(() => {
          this.dialog.close();
          this.launcher.hidden = Boolean(this.readState().subscribed);
          if (this.returnFocus?.isConnected && this.returnFocus !== document.body) this.returnFocus.focus({ preventScroll: true });
          else if (!this.launcher.hidden) this.launcher.focus({ preventScroll: true });
        }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 280);
      }
      startDrag(event) {
        if (!event.isPrimary || event.button !== 0) return;
        this.suppressClick = false;
        const box = this.launcher.getBoundingClientRect();
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: box.left, top: box.top, moved: false };
        this.launcher.setPointerCapture(event.pointerId);
      }
      moveDrag(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const dx = event.clientX - this.drag.x, dy = event.clientY - this.drag.y;
        if (!this.drag.moved && Math.hypot(dx, dy) < 6) return;
        this.drag.moved = true;
        this.launcher.setAttribute('data-dragging', '');
        this.setPosition(this.drag.left + dx, this.drag.top + dy);
      }
      endDrag() {
        if (!this.drag) return;
        this.suppressClick = this.drag.moved;
        if (this.drag.moved) {
          const box = this.launcher.getBoundingClientRect();
          this.writeState({ x: box.left / Math.max(1, innerWidth - box.width), y: box.top / Math.max(1, innerHeight - box.height) });
        }
        this.launcher.removeAttribute('data-dragging');
        this.drag = null;
      }
      setPosition(x, y) {
        const box = this.launcher.getBoundingClientRect();
        const width = window.visualViewport?.width || innerWidth;
        const height = window.visualViewport?.height || innerHeight;
        this.launcher.style.left = `${Math.max(12, Math.min(x, width - box.width - 12))}px`;
        this.launcher.style.top = `${Math.max(12, Math.min(y, height - box.height - 12))}px`;
        this.launcher.style.right = 'auto'; this.launcher.style.bottom = 'auto';
      }
      restorePosition() {
        const saved = this.readState();
        if (Number.isFinite(saved.x) && Number.isFinite(saved.y)) {
          const box = this.launcher.getBoundingClientRect();
          this.setPosition(saved.x * (innerWidth - box.width), saved.y * (innerHeight - box.height));
        }
      }
      clampPosition() {
        if (this.launcher.hidden || !this.launcher.style.left) return;
        const box = this.launcher.getBoundingClientRect(); this.setPosition(box.left, box.top);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
